/** GOV.UK Frontend colour tokens */
export const GOVUK_COLOURS = {
  midGrey: '#b1b4b6',
  lightGrey: '#f3f2f1',
  darkGrey: '#505a5f',
  blue: '#1d70b8',
  green: '#00703c',
  red: '#d4351c',
  yellow: '#ffdd00',
  purple: '#4c2c92',
} as const
